/**
 * The drivers module's routes, owned by the feature. D5.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const DriversPage = lazy(() => import('./DriversPage'));
const DriverProfile = lazy(() => import('./DriverProfile'));

export const driversRoutes: RouteObject[] = [
    { path: 'drivers', element: <DriversPage /> },
    { path: 'drivers/:id', element: <DriverProfile /> },
];
